/* eslint-disable react/sort-comp */
// @flow
import React, { PureComponent } from 'react';
import Cookies from 'universal-cookie';
import fetchJsonp from 'fetch-jsonp';
import idx from 'idx';
import RexButton from 'rex-button';

import ButtonSupplimentaryText, {
  ButtonSupplimentaryTextNotice,
  ButtonSupplimentaryTextLink,
} from './ButtonSupplimentaryText/ButtonSupplimentaryText';
import Below from './Below/Below';
import Above from './Above/Above';
import styles from './App.scss';
import ValidationText from './ValidationText';
import {
  theme,
  validationTextMap,
  apiCheckURL,
  apiApplyURL,
  makeLoginRedirectURL,
  buttonStateMap,
  buttonStateText,
  REDIRECTION_DELAY_AFTER_SUCCESS,
  REDIRECTION_DELAY_AFTER_IN_PROCESS,
} from '../constant';
import type { buttonPropsType, buttonPropsRedirectionType, responseType } from './types';
import {
  isValidState,
  sendRAT,
  isDisabled,
  buttonStateFactory,
  validationTextFactory,
  isCheckOK,
  redirectToUrl,
} from '../util';

declare var __DEV__: boolean;

const cookies = new Cookies();

export default class RexCampaignButton extends PureComponent<buttonPropsType, void> {
  isCheckboxMandatory: boolean;
  isRedirectionEnabled: boolean;
  theme: string;
  below: ?Object;
  redirection: ?buttonPropsRedirectionType;

  static isLoggedIn = () => !!cookies.get('Rz');

  constructor(props: buttonPropsType) {
    super(props);

    this.theme = idx(props, _ => _.rexButton.theme) || theme.RED;
    this.below = idx(props, _ => _.rexButton.below);
    this.redirection = idx(props, _ => _.rexButton.redirection);

    this.isCheckboxMandatory = !!this.below && this.below.isCheckboxMandatory;
    this.isRedirectionEnabled = !!this.redirection && this.redirection.enabled === true;
  }

  componentDidMount() {
    if (this.props.shouldCheck) {
      this.checkApplyStatus();
    }
  }

  componentDidUpdate() {
    const { buttonState: { buttonState } } = this.props;

    if (buttonState === buttonStateMap.IN_PROCESS && this.isRedirectionEnabled && this.redirection) {
      // Redirect to URL
      const { url } = this.redirection;
      redirectToUrl(url, REDIRECTION_DELAY_AFTER_IN_PROCESS).then(() => {
        if (this.props.shouldCheck) {
          this.checkApplyStatus();
        }
      });
    }
  }

  onCheckChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const { rexButton: { cId }, updateButtonState } = this.props;
    const newState = {}; // this is made empty intentionally, because flowtype would seal an non-empty object

    if (this.below && this.isCheckboxMandatory) {
      newState.buttonState = e.currentTarget.checked ? buttonStateMap.ENABLED : buttonStateMap.TOC_NOT_CHECKED;
    }

    newState.isChecked = e.currentTarget.checked;

    updateButtonState(newState, cId);
  };

  checkApplyStatus = () => {
    const { rexButton: { cId }, updateButtonState } = this.props;

    if (!this.constructor.isLoggedIn()) {
      updateButtonState(
        {
          validationText: validationTextMap.NOT_LOGGED_IN,
        },
        cId
      );

      return;
    }

    if (window.localStorage && isValidState(localStorage.getItem(`rex-campaign-${cId}`))) {
      const cachedState = localStorage.getItem(`rex-campaign-${cId}`);

      updateButtonState(
        {
          buttonState: cachedState,
        },
        cId
      );

      return;
    }

    // if the user already logged in, start the apply status check
    updateButtonState({ buttonState: buttonStateMap.LOADING }, cId);

    fetchJsonp(`${apiCheckURL}${cId}`)
      .then(res => res.json())
      .then(res => {
        const { buttonState: { isChecked } } = this.props;

        if (isCheckOK(res)) {
          // we don't need validation text for totally successful case
          // just the buttonState would suffice
          if (this.below && this.isCheckboxMandatory && !isChecked) {
            updateButtonState(
              {
                buttonState: buttonStateMap.TOC_NOT_CHECKED,
              },
              cId
            );
          } else {
            updateButtonState(
              {
                buttonState: buttonStateMap.ENABLED,
              },
              cId
            );
          }
        } else {
          this.resActionFactory(res);
        }
      })
      .catch(err => {
        if (__DEV__) {
          console.error(err);
        }

        if (this.below && this.isCheckboxMandatory && !this.props.isChecked) {
          updateButtonState(
            {
              buttonState: buttonStateMap.TOC_NOT_CHECKED,
              validationText: validationTextMap.FALLBACK,
            },
            cId
          );
        } else {
          updateButtonState(
            {
              buttonState: buttonStateMap.ENABLED,
              validationText: validationTextMap.FALLBACK,
            },
            cId
          );
        }
      });
  };

  resActionFactory = (res: responseType) => {
    const { rexButton: { id, cId, onEntrySuccess }, updateButtonState } = this.props;
    const newButtonState = buttonStateFactory(res);

    sendRAT(cId, true, id);

    if (window.localStorage) {
      switch (newButtonState) {
        case buttonStateMap.SUCCESS:
        case buttonStateMap.ALREADY_APPLIED: {
          localStorage.setItem(`rex-campaign-${cId}`, 'ALREADY_APPLIED');
          break;
        }
        case buttonStateMap.EXPIRED: {
          localStorage.setItem(`rex-campaign-${cId}`, 'EXPIRED');
          break;
        }
        default:
          break;
      }
    }

    // Fire a callback for success
    if (newButtonState === buttonStateMap.SUCCESS && typeof onEntrySuccess === 'function') {
      onEntrySuccess();
    }

    if (newButtonState === buttonStateMap.SUCCESS) {
      // In case of redirection is enabled, reserve the next actions
      if (this.isRedirectionEnabled && this.redirection) {
        // Set buttonState to IN_PROCESS state
        setTimeout(() => {
          updateButtonState({ buttonState: buttonStateMap.IN_PROCESS }, cId);
        }, REDIRECTION_DELAY_AFTER_SUCCESS);
      }
    }

    updateButtonState(
      {
        buttonState: newButtonState,
        validationText: validationTextFactory(res),
      },
      cId
    );
  };

  applyForCampaign = () => {
    const {
      updateButtonState,
      buttonState: { isChecked },
      rexButton: { id, cId, cCode, onEntry, onEntryFail },
    } = this.props;
    /* eslint-disable */
    /*
    {
      code: "200",
      message: "OK",
      result: "2"
    }

    [message]

      OK: Normal
      Server Error: In Trouble
      Invalid Parameter: something wrong with parameter

    [campaign entry's result]

      0: complete entry
      1: already entered
      2: out side of entry period
      3: can not enter due to not allowed device

      when not found campaign, "not found campaign" is on it.
    */
    /* eslint-enable */
    if (!this.constructor.isLoggedIn()) {
      window.location.href = makeLoginRedirectURL(cCode);

      return;
    }

    updateButtonState({ buttonState: buttonStateMap.LOADING }, cId);

    if (typeof onEntry === 'function') {
      onEntry();
    }

    // apply API
    fetchJsonp(`${apiApplyURL}${cCode}${isChecked ? '&ekey=checked' : '&ekey=unchecked'}`)
      .then(res => res.json())
      .then(this.resActionFactory, () => {
        if (typeof onEntryFail === 'function') {
          onEntryFail();
        }

        sendRAT(cId, false, id);
        updateButtonState({ buttonState: buttonStateMap.RETRY }, cId);
      });
  };

  ifShowStatements(): boolean {
    const { buttonState } = this.props;

    if (
      buttonState.buttonState === buttonStateMap.LOGIN ||
      buttonState.buttonState === buttonStateMap.LOADING ||
      buttonState.buttonState === buttonStateMap.ALREADY_APPLIED ||
      buttonState.buttonState === buttonStateMap.EXPIRED ||
      buttonState.buttonState === buttonStateMap.IN_PROCESS ||
      buttonState.buttonState === buttonStateMap.SUCCESS
    ) {
      return false;
    }

    return true;
  }

  renderAbove = () => {
    const { rexButton: { above } } = this.props;

    if (this.ifShowStatements() && above) {
      return <Above {...above} theme={this.theme} />;
    }

    return null;
  };

  renderBelow = () => {
    const { buttonState: { isChecked }, rexButton: { id, below } } = this.props;

    if (this.ifShowStatements() && below) {
      return (
        <Below
          {...below}
          id={id}
          onCheckChange={this.onCheckChange}
          cId={this.props.rexButton.cId}
          isChecked={isChecked}
          theme={this.theme}
        />
      );
    }

    return null;
  };

  ifShowButtonSupplimentaryText(): boolean {
    const { buttonState } = this.props;

    if (buttonState.buttonState === buttonStateMap.LOGIN || buttonState.buttonState === buttonStateMap.EXPIRED) {
      return false;
    }

    return true;
  }

  renderButtonSupplimentaryText = () => {
    const { buttonState: { buttonState } } = this.props;

    if (this.ifShowButtonSupplimentaryText() && this.isRedirectionEnabled && this.redirection) {
      const { url, pageTitle } = this.redirection;
      const { linkText = `${pageTitle}${buttonStateText.IN_PROCESS}` } = this.redirection;
      const type =
        buttonState === buttonStateMap.ALREADY_APPLIED ? ButtonSupplimentaryTextLink : ButtonSupplimentaryTextNotice;
      const noticeText = `${pageTitle}${buttonStateText.IN_PROCESS}`;

      return (
        <ButtonSupplimentaryText
          type={type}
          noticeText={noticeText}
          linkText={linkText}
          linkUrl={url}
          theme={this.theme}
        />
      );
    }

    return null;
  };

  render() {
    const { buttonState } = this.props;

    if (!buttonState || !buttonState.buttonState) {
      return null;
    }

    const buttonText =
      // ALREADY_APPLIED
      (buttonState.buttonState === buttonStateMap.ALREADY_APPLIED &&
        idx(this.props, _ => _.rexButton.alreadyAppliedText)) ||
      // IN_PROCESS
      (buttonState.buttonState === buttonStateMap.IN_PROCESS &&
        this.isRedirectionEnabled &&
        this.redirection &&
        `${this.redirection.pageTitle}${buttonStateText.IN_PROCESS}...`) ||
      // Default texts
      buttonStateText[buttonState.buttonState];

    return (
      <div id={styles.rex_campaign_btn}>
        {this.renderAbove()}
        <ValidationText buttonState={buttonState.buttonState} validationText={buttonState.validationText} />
        <RexButton
          theme={this.theme}
          buttonState={buttonState.buttonState}
          onClick={this.applyForCampaign}
          text={buttonText}
          hasArrow={this.isRedirectionEnabled}
          isDisabled={isDisabled(buttonState.buttonState)}
        />
        {this.renderButtonSupplimentaryText()}
        {this.renderBelow()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js